import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React from 'react';

interface EditReasonDialogProps {
  open: boolean;
  onClose: () => void;
  businessName: string;
  newReason: string;
  onReasonChange: (reason: string) => void;
  onSave: () => void;
  loading: boolean;
}

const EditReasonDialog: React.FC<EditReasonDialogProps> = ({
  open,
  onClose,
  businessName,
  newReason,
  onReasonChange,
  onSave,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      maxWidth="lg"
    >
      <DialogTitle
        id="form-dialog-title"
        sx={{ fontSize: '1.1rem', fontWeight: 600 }}
      >
        Editar razón de {businessName}
      </DialogTitle>
      <DialogContent>
        {loading && (
          <div style={{ minHeight: '70px' }}>
            <CenteredCircularProgress type="dialog" />
          </div>
        )}
        {!loading && (
          <TextField
            autoFocus
            margin="dense"
            id="newReason"
            label="Razón"
            type="text"
            fullWidth
            value={newReason}
            onChange={(e) => onReasonChange(e.target.value)}
            multiline
            rows={4}
            placeholder="Ingresar nueva razón..."
            sx={{
              '& .MuiInputBase-input': {
                fontSize: '0.9rem',
              },
              '& .MuiInputLabel-root': {
                fontSize: '0.9rem',
              },
            }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary" disabled={loading}>
          Cancelar
        </CustomButton>
        <CustomButton onClick={onSave} color="primary" disabled={loading}>
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditReasonDialog;
